<script lang="ts">
import { Emit, Options, Vue } from "vue-property-decorator";
import { AppointmentType, SelectItem, translateAppointmentType, appointmentTypeForSelection } from "@model/models";

@Options({})
export default class SelectAppointmentType extends Vue {
    public value: string = "";

    appointmentTypeData: SelectItem<AppointmentType>[] = appointmentTypeForSelection.map((x: AppointmentType) => ({
        label: translateAppointmentType(x),
        value: x,
    }));

    @Emit("change")
    onChange(value: any) {
        this.value = value;
    }
}
</script>

<template lang="pug">
el-select(v-model="value", @change="onChange", placeholder="選擇類別")
  el-option(v-for="type in appointmentTypeData" :key="type.value" :label="type.label" :value="type.value")
</template>

<style scoped lang="scss"></style>
